import { useState } from 'react'
import { Select, LinkList, Link } from '@postenbring/hedwig-react'

export const CountrySelect = ({ countries = [], placeholder = 'Select a country', linkVariant = 'default' }) => {
    const [selected, setSelected] = useState()

    const handleOnSelect = (event) => {
        setSelected(countries.find((element) => element.value === event.target.value))
    }

    return (
        <>
            <Select
                onChange={(val) => handleOnSelect(val)}
                aria-label={placeholder}
            >
                <option value=''>{placeholder}</option>
                {countries.map((country, index) => (
                    <option key={index} value={country.value}>
                        {country.label}
                    </option>
                ))}
            </Select>
            {selected && (
                <LinkList className='hds-mt-20-24'>
                    {selected.urls.map((link, index) => (
                        <li key={index}>
                            <Link href={link.url} variant={linkVariant}>{link.url.replace(/^https?:\/\//, '')}</Link>
                        </li>
                    ))}
                </LinkList>
            )}
        </>
    )
}
